import { render, staticRenderFns } from "./TheWorkerFooter.vue?vue&type=template&id=b5374eb2&"
import script from "./TheWorkerFooter.vue?vue&type=script&lang=js&"
export * from "./TheWorkerFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheWorkerFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports